import React, {useEffect, useRef, useState} from 'react';
import {Tab, Tabs} from "react-bootstrap";
import axios from '../../services/axiosInstance';
import AdminYmdEvent from "../../components/web/layoutsadmin/AdminYmdEvent";
import AdminPageEvent from "../../components/web/layoutsadmin/AdminPageEvent";
import AdminSearchEvent from "../../components/web/layoutsadmin/AdminSearchEvent";
import {MdKeyboardArrowDown, MdOutlineChangeCircle} from "react-icons/md";
import maCateImg from "../../assets/img/m-a-cate.png";
import commonCheck from "../../assets/img/commonCheck.png";
import commonClose from "../../assets/img/commonClose.png";
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import PickupTrackAddPopup from "../../components/web/modal/PickupTrackAddPopup";

function AdminPickupPg() {

    const [pickupWaitList, setPickupWaitList] = useState([]);
    const [pickupList, setPickupList] = useState([]);
    const token = localStorage.getItem('adminToken');

    const [tabSt, setTabSt] = useState('픽업대기');

    const handleSelectTabs = ((key) => {
        setTabSt(key);
    })

    const [displayLimitPickupWait, setDisplayLimitPickupWait] = useState(10);
    const [displayLimitPickup, setDisplayLimitPickup] = useState(10);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [pickupList.length, displayLimitPickup, pickupWaitList.length, displayLimitPickupWait]);

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) return;
        if (pickupList.length > displayLimitPickup && displayLimitPickup < 30
            || pickupWaitList.length > displayLimitPickupWait && displayLimitPickupWait < 30) {
            setDisplayLimitPickupWait(prevLimit => prevLimit + perPg);
        }
    };

    const loadMoreData = () => {
        setDisplayLimitPickup(prevLimit => prevLimit + perPg);
        setDisplayLimitPickupWait(prevLimit => prevLimit + perPg);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [perPg, setperPg] = useState(10);
    const indexOfLast = currentPage * perPg;
    const indexOfFirst = indexOfLast - perPg;
    const handleSelectChange = (eOrValue) => {
        let value;
        if (typeof eOrValue === 'object' && eOrValue.target) {
            value = eOrValue.target.value;
        } else {
            value = eOrValue;
        }
        const newPerPage = parseInt(value);
        setperPg(newPerPage);
        setDisplayLimitPickup(newPerPage);
        setDisplayLimitPickupWait(newPerPage);
        setCurrentPage(1);
    };

    const [searchInput, setSearchInput] = useState('');
    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const searchPickupWaitData = pickupWaitList.filter((cData) => (
        (cData?.name || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.address || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.addressDt || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.zipcode || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.trackNum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.telnum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.memberDTO?.userName || '').toLowerCase().includes(searchInput.toLowerCase())
    ));

    const searchPickupData = pickupList.filter((cData) => {
        return (
            (cData?.name || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.address || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.addressDt || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.zipcode || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.trackNum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.telnum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.memberDTO?.userName || '').toLowerCase().includes(searchInput.toLowerCase())
        );
    });


    const selectPickupWaitHistoryList = (() => {
        axios({
            method: 'get',
            url: '/pickup/selectPickupHistoryList',
            params: {
                status: '0'
            },
        })
            .then((response) => {
                console.log("반환값 : ", response.data)
                const sortedData = response.data.sort((a, b) => a.seqNum - b.seqNum);
                setPickupWaitList(sortedData)
            })
            .catch((error) => {
                console.log("조회실패 : ", error)
            })
    })


    // 여기서부터 픽업신청
    const [pickupStartDate, setPickupStartDate] = useState('');
    const [pickupEndDate, setPickupEndDate] = useState('');
    const pickupStartHandle = (e) => {
        setPickupStartDate(e.target.value);
    };
    const pickupEndHandle = (e) => {
        setPickupEndDate(e.target.value);
    };

    useEffect(() => {
        const today = new Date();
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

        const formatDateString = (date) => {
            // return date.toISOString().split('T')[0];
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        setPickupStartDate(formatDateString(oneMonthAgo));
        setPickupEndDate(formatDateString(today));
    }, []);

    const selectPickupHistoryList = (() => {
        const formattedStartDate = pickupStartDate.replace(/-/g, '');
        const formattedEndDate = pickupEndDate.replace(/-/g, '');
        axios({
            method: 'get',
            url: '/pickup/selectPickupHistoryList',
            params: {
                startDate: formattedStartDate,
                endDate: formattedEndDate,
            },
        })
            .then((response) => {
                const sortedData = response.data.sort((a, b) => a.seqNum - b.seqNum);
                console.log("sortedData : ", sortedData)
                setPickupList(sortedData)
            })
            .catch((error) => {
                console.log("조회실패 : ", error)
            })
    })

    // 공통
    useEffect(() => {
        setDisplayLimitPickup(perPg);
        setDisplayLimitPickupWait(perPg);
    }, [perPg]);

    useEffect(() => {
        if (tabSt === "픽업대기") {
            selectPickupWaitHistoryList();
        } else if (tabSt === "픽업신청" && pickupStartDate && pickupEndDate) {
            selectPickupHistoryList();
        }
    }, [tabSt, pickupStartDate, pickupEndDate]);

    const [confirmPickupSt, setConfirmPickupSt] = useState(false);
    const confirmPickupMsg1 = "픽업접수가 완료되었습니까?";
    const confirmPickupMsg2 = "진행 시 접수완료로 처리됩니다";

    const [cancelPickupSt, setCancelPickupSt] = useState(false);
    const cancelPickupMsg1 = "픽업신청을 취소하시겠습니까?";
    const cancelPickupMsg2 = "진행 시 픽업신청이 취소처리 됩니다";

    const [pickupSeqNum, setPickupSeqNum] = useState(null);

    const openConfirmPickupSt = ((seqNum) => {
        setPickupSeqNum(seqNum);
        setConfirmPickupSt(true);
    })
    const closeConfirmPickupSt = (() => {
        setPickupSeqNum(null);
        setConfirmPickupSt(false);
    })

    const openCancelPickupSt = ((seqNum) => {
        setPickupSeqNum(seqNum);
        setCancelPickupSt(true);
    })
    const closeCancelPickupSt = (() => {
        setPickupSeqNum(null);
        setCancelPickupSt(false);
    })

    const modifyPickupStatus = (seqNum) => {
        const targetSeqNum = pickupSeqNum || seqNum;
        axios({
            method: 'post',
            url: '/pickup/modifyPickupStatus',
            params: {
                seqNum: targetSeqNum,
                status: confirmPickupSt ? '1' : cancelPickupSt ? '2' : null
            }
        })
            .then(async (res) => {
                // 각 리스트에 반환된 seqNum 모두 제거
                const data = res.data;
                setPickupWaitList(prev => prev.filter(item => item.seqNum !== data.seqNum));
                setPickupList(prev => prev.map(comment => comment.seqNum === data.seqNum ? data : comment));

                if (confirmPickupSt) {
                    closeConfirmPickupSt();
                } else if (cancelPickupSt) {
                    closeCancelPickupSt();
                }
            })
            .catch((error) => {
                console.log("픽업데이터 상태변경 실패 : ", error)
            });
    };

    const [trackNumAddSt, setTrackNumAddSt] = useState(false);
    const handleChangeValue = (seqNum, currentTrackNum) => {
        setPickupSeqNum(seqNum); // 수정할 seqNum 저장
        setTrackNumAddSt(true);  // 팝업 열기
    };
    const closeTrackNumAddSt = () => {
        setTrackNumAddSt(false);
    }
    const handleSaveTrackNum = (updatedData) => {
        // DB에 저장된 최신 데이터를 받아 해당 seqNum의 데이터만 교체 (실시간 UI 반영)
        setPickupList(prev => prev.map(item =>
            item.seqNum === updatedData.seqNum ? updatedData : item
        ));
        // 필요 시 대기 리스트도 업데이트
        setPickupWaitList(prev => prev.map(item =>
            item.seqNum === updatedData.seqNum ? updatedData : item
        ));
    };



    return (
        <div className="AdminDepositSetPg font-t-cont">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">픽업관리</p>
            </div>
            <div className="admin-wrap">
                <div className="admin-wrap-card">
                    <Tabs defaultActiveKey="픽업대기" onSelect={handleSelectTabs}>

                        {/*픽업대기탭*/}
                        <Tab eventKey="픽업대기" title="&nbsp;&nbsp;&nbsp;픽업대기&nbsp;&nbsp;&nbsp;">
                            <div className="admin-event-wrap-btn m-t-15">
                                <AdminPageEvent perPg={perPg} handleSelectChange={handleSelectChange}/>
                                {/*여기서부터 커스텀 예치금 type 셀렉트*/}

                                <AdminSearchEvent searchInput={searchInput}
                                                  handleSearchInputChange={handleSearchInputChange}/>
                            </div>
                            <div className="m-t-15">
                                <div className="div-tb m-b-10">
                                    <div className="div-tb-head ht-60">
                                        <div style={{width: "30px"}}><p>번호</p></div>
                                        <div style={{width: "80px"}}><p>성함</p></div>
                                        <div style={{width: "260px"}}><p>주소</p></div>
                                        <div style={{width: "80px"}}><p>상세주소</p></div>
                                        <div style={{width: "80px"}}><p>연락처</p></div>
                                        <div style={{width: "150px"}}><p>부피 & 무게</p></div>
                                        <div style={{width: "80px"}}><p>운송장번호</p></div>
                                        <div style={{width: "50px"}}><p>타입</p></div>
                                        <div style={{width: "50px"}}><p>상태</p></div>
                                    </div>
                                    {searchPickupWaitData.slice(0, displayLimitPickupWait).map((pw, i) => (
                                        // {depHistoryList && depHistoryList.map((dep, i) => (
                                        <div key={i} className="div-tb-body ht-70">
                                            <div style={{width: "30px"}}><p>{i + 1}</p></div>
                                            <div style={{width: "80px"}}><p
                                                className="font-b">{pw.name} (BT {pw?.memberDTO?.mbNum})</p>
                                            </div>
                                            <div style={{width: "260px"}}><p>{pw.address}</p></div>
                                            <div style={{width: "80px"}}><p>{pw.addressDt}</p></div>
                                            <div style={{width: "80px"}}><p>{pw.telnum}</p></div>
                                            <div style={{width: "150px"}}><p>{pw.wid} * {pw.ver} * {pw.hei} - {pw.realWeight}kg</p></div>
                                            <div style={{width: "80px"}}><p>{pw.trackNum}</p></div>

                                            <div style={{width: "50px"}}><p>{pw.type === '0' ? '해외픽업' : '국내픽업'}</p>
                                            </div>
                                            <div style={{width: "50px"}}>
                                                <div className="font-b" style={{
                                                    fontSize: "13px",
                                                    color: pw?.status === '0' ? "#7c9edc" : pw?.status === '1' ? "#48dc50" : '#ff7575'
                                                }}>
                                                    {pw?.status === '0' ?
                                                        <div className="user-center" style={{width: "40px"}}>
                                                            <img
                                                                className="c-point wd-28 ht-28 m-a-opc-07 img-hover-opc"
                                                                alt="closeImage"
                                                                src={commonCheck}
                                                                onClick={() => openConfirmPickupSt(pw.seqNum)}/>
                                                            <img
                                                                className="c-point wd-28 ht-28 m-a-opc-07 img-hover-opc"
                                                                alt="closeImage"
                                                                src={commonClose}
                                                                onClick={() => openCancelPickupSt(pw.seqNum)}/>
                                                        </div>
                                                        : pw?.status === '1' ? '완료' : '취소'}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {displayLimitPickupWait >= 30 && searchPickupWaitData.length > displayLimitPickupWait && (
                                <div className="text-center m-t-20">
                                    <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                        <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                                    </button>
                                </div>
                            )}
                        </Tab>

                        {/*픽업신청탭*/}
                        <Tab eventKey="픽업신청" title="&nbsp;&nbsp;&nbsp;픽업신청&nbsp;&nbsp;&nbsp;">
                            <div className="admin-event-wrap-btn m-t-15">
                                <AdminPageEvent perPg={perPg} handleSelectChange={handleSelectChange}/>
                                <AdminYmdEvent startDate={pickupStartDate} endDate={pickupEndDate}
                                               startHandle={pickupStartHandle} endHandle={pickupEndHandle}/>
                                <AdminSearchEvent searchInput={searchInput}
                                                  handleSearchInputChange={handleSearchInputChange}/>
                            </div>
                            <div className="m-t-15">
                                <div className="div-tb m-b-10">
                                    <div className="div-tb-head ht-60">
                                        <div style={{width: "30px"}}><p>번호</p></div>
                                        <div style={{width: "80px"}}><p>성함</p></div>
                                        <div style={{width: "260px"}}><p>주소</p></div>
                                        <div style={{width: "80px"}}><p>상세주소</p></div>
                                        <div style={{width: "80px"}}><p>연락처</p></div>
                                        <div style={{width: "150px"}}><p>부피 & 무게</p></div>
                                        <div style={{width: "80px"}}><p>운송장번호</p></div>
                                        <div style={{width: "50px"}}><p>타입</p></div>
                                        <div style={{width: "50px"}}><p>상태</p></div>
                                    </div>
                                    {searchPickupData.slice(0, displayLimitPickup).map((p, i) => (
                                        // {depHistoryList && depHistoryList.map((dep, i) => (
                                        <div key={i} className="div-tb-body ht-70">
                                            <div style={{width: "30px"}}><p>{i + 1}</p></div>
                                            <div style={{width: "80px"}}><p
                                                className="font-b">{p.name} (BT {p?.memberDTO?.mbNum})</p>
                                            </div>
                                            <div style={{width: "260px"}}><p>{p.address}</p></div>
                                            <div style={{width: "80px"}}><p>{p.addressDt}</p></div>
                                            <div style={{width: "80px"}}><p>{p.telnum}</p></div>
                                            <div style={{width: "150px"}}>
                                                <p>{p.wid} * {p.ver} * {p.hei} - {p.realWeight}kg</p></div>

                                            <div className="user-center flex-row wd-120 ht-100pc gap6">
                                                {p.trackNum && (
                                                    <p style={{margin: 0, lineHeight: "1", color:"#7c9edc", fontWeight:"bold"}} className="font-b">
                                                        {p.trackNum}
                                                    </p>
                                                )}
                                                <div className="display-flex align-center">
                                                    <MdOutlineChangeCircle
                                                        className="c-point btorage-hover btn-click-event m-a-opc-07 font-s-22"
                                                        onClick={() => handleChangeValue(p.seqNum, p.trackNum)}
                                                    />
                                                </div>
                                            </div>

                                            <div style={{width: "50px"}}><p>{p.type === '0' ? '해외픽업' : '국내픽업'}</p>
                                            </div>
                                            <div style={{width: "50px"}}>
                                                <div className="font-b" style={{
                                                    fontSize: "13px",
                                                    color: p?.status === '0' ? "#7c9edc" : p?.status === '1' ? "#48dc50" : '#ff7575'
                                                }}>
                                                    {p?.status === '0' ?
                                                        <div className="user-center" style={{width: "40px"}}>
                                                            <img
                                                                className="c-point wd-28 ht-28 m-a-opc-07 img-hover-opc"
                                                                alt="closeImage"
                                                                src={commonCheck}
                                                                onClick={() => openConfirmPickupSt(p.seqNum)}/>
                                                            <img
                                                                className="c-point wd-28 ht-28 m-a-opc-07 img-hover-opc"
                                                                alt="closeImage"
                                                                src={commonClose}
                                                                onClick={() => openCancelPickupSt(p.seqNum)}/>
                                                        </div>
                                                        : p?.status === '1' ? '완료' : '취소'}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {displayLimitPickup >= 30 && searchPickupData.length > displayLimitPickup && (
                                <div className="text-center m-t-20">
                                    <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                        <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                                    </button>
                                </div>
                            )}
                        </Tab>
                    </Tabs>

                </div>
            </div>


            {confirmPickupSt ?
                <MsgSelectModal confirmPickupSt={confirmPickupSt} confirmPickupMsg1={confirmPickupMsg1} confirmPickupMsg2={confirmPickupMsg2}
                                closeConfirmPickupSt={closeConfirmPickupSt} pickupSeqNum={pickupSeqNum} modifyPickupStatus={modifyPickupStatus}/>
                :
                cancelPickupSt ?
                    <MsgSelectModal cancelPickupSt={cancelPickupSt} cancelPickupMsg1={cancelPickupMsg1} cancelPickupMsg2={cancelPickupMsg2}
                                    closeCancelPickupSt={closeCancelPickupSt} pickupSeqNum={pickupSeqNum} modifyPickupStatus={modifyPickupStatus}/>
                    :
                    trackNumAddSt ?
                        <PickupTrackAddPopup trackNumAddSt={trackNumAddSt} closeTrackNumAddSt={closeTrackNumAddSt}
                                             pickupSeqNum={pickupSeqNum} handleSaveTrackNum={handleSaveTrackNum}/>
                        :
                    null
            }

        </div>
    );
}

export default AdminPickupPg
